import variationSetsService from 'packages/services/variationSetsService';

export const download = (jobId: number, jobVariationId?: number) => {
    variationSetsService.generateSignedUrlForVariationDownload(jobId, jobVariationId).then((signedUrl) => {
        if (!signedUrl) {
            return;
        }

        const a = document.createElement('a');
        a.setAttribute('href', signedUrl);
        a.setAttribute('target', '_blank');
        a.setAttribute('download', '');
        a.click();
    });
};

export const downloadPdf = (jobId: number) => {
    variationSetsService.generateSignedUrlForVariationDownload(jobId).then((signedUrl) => {
        if (!signedUrl) {
            return;
        }

        if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
            const a = document.createElement('a');
            a.setAttribute('href', signedUrl);
            a.setAttribute('target', '_blank');
            a.setAttribute('download', '');
            a.click();
        } else {
            window.location.href = signedUrl.startsWith('http') ? signedUrl : `${window.location.origin}${signedUrl}`;
        }
    });
};
